import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const ProtectedRoute = () => {
    // console.log("Using protected route hehe");
    
    const { loading, isAuthenticated } = useSelector((state) => state.user);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the user is not authenticated and navigate to login page if needed
        if (!loading && !isAuthenticated) {
            // Preserve the query string too (not just the path) -- e.g. a
            // referral link's ?ref=CODE must survive this bounce through
            // login/signup, see Signup.jsx's `next`-unwrapping logic.
            const redirectPath = `/login?next=${encodeURIComponent(location.pathname + location.search)}`;
            navigate(redirectPath, { replace: true });
        }
    }, [loading, isAuthenticated, location.pathname, navigate]);

    return (
        <>
            {loading === false && isAuthenticated ? (
                <Outlet />
            ) : null}
        </>
    );
};

export default ProtectedRoute;
